  <angular-multiselect #dropdownElem [data]="itemList" [(ngModel)]="selectedItems" [settings]="settings" 
      (onSelect)="onItemSelect($event)"
      (onDeSelect)="OnItemDeSelect($event)" 
      (onSelectAll)="onSelectAll($event)" 
      (onDeSelectAll)="onDeSelectAll($event)"
      (onOpen)="onOpen($event)"
      (onClose)="onClose($event)">
  </angular-multiselect>
<br>
<br>
<div class="row">
  <div class="col-md-4">
      <h5>On Select</h5>
      <textarea class="output-text" [(ngModel)]="selectedItemString">Event output goes here...
      </textarea>
  </div>
  <div class="col-md-4">
      <h5>On Un-select</h5>
      <textarea class="output-text" [(ngModel)]="unSelectedItemString">Event output goes here...
      </textarea>
  </div>
  <div class="col-md-4">
      <h5>On Open</h5>
      <textarea class="output-text" [(ngModel)]="openString">Event output goes here...
      </textarea>
  </div>
  <div class="col-md-4">
      <h5>On Close</h5>
      <textarea class="output-text" [(ngModel)]="closeString">Event output goes here...
      </textarea>
  </div>
  <div class="col-md-4">
      <h5>On Select All</h5>
      <textarea class="output-text" [(ngModel)]="selectAllString">Event output goes here...
      </textarea>
  </div>
  <div class="col-md-4">
      <h5>On Un-Select All</h5>
      <textarea class="output-text" [(ngModel)]="unSelectAllString">Event output goes here...
      </textarea>
  </div>
</div>